import { BroadcastChannel } from 'broadcast-channel';
let channel;
const GROUP_PREFIX = 'sharedWorker_';
function getChannel(group) {
    if (!channel) {
        channel = new BroadcastChannel(`${GROUP_PREFIX}${group}`);
    }
    return channel;
}
export const addEventListener = (group, event, callback) => {
    const channel = getChannel(group);
    channel.addEventListener('message', (msg) => {
        const message = JSON.parse(msg);
        // console.log(currentTimeStr() + ' receive msg:', msg)
        if (message.event === event) {
            const evt = new CustomEvent(event, {
                detail: message.params
            });
            callback(evt);
        }
    });
};
export const dispatchAppEvent = (group, event, params = {}) => {
    const channel = getChannel(group);
    const msg = JSON.stringify({
        event,
        params
    });
    // console.log(currentTimeStr() + ' send msg:', msg)
    channel.postMessage(msg);
};
